import Image from "next/image";

export const ProductItemPartner = ({ src, title, desc, href }) => {
  return (
    <>
      <div className="col-span-1 space-y-2">
        <figure className="relative box-border block aspect-3/1 w-full border border-solid border-bdc-light">
          <Image
            src={src}
            alt={title}
            quality={80}
            layout="fill"
            objectFit="cover"
          />
        </figure>
        <h3 className="font-bold text-pri fluid-text-[14px,18px]">
          <a
            href={href}
            target="_blank"
            rel="noreferrer noopener"
            className="--tl --ff"
          >
            {title}
          </a>
        </h3>
        <div className="grid-cols-1 leading-relaxed  text-txt-base fluid-text-[12px,14px]">
          <div
            dangerouslySetInnerHTML={{
              __html: `${desc}`,
            }}
          />
        </div>
      </div>
    </>
  );
};
